import script from "./Rodape.vue?vue&type=script&setup=true&lang=js"
export * from "./Rodape.vue?vue&type=script&setup=true&lang=js"

import "./Rodape.vue?vue&type=style&index=0&id=7519ef96&lang=scss&scoped=true"

import exportComponent from "/var/www/html/resources/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7519ef96"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
